import styled from '@emotion/styled';
import { useRef, forwardRef } from 'react';
import { useSearchField } from 'react-aria';
import { useSearchFieldState } from 'react-stately';

import { mergeRefs } from '../../../lib/mergeRefs';
import { Glyph } from '../Glyph';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';
import glyphStyles from '../Glyph.module.css';

import { TagGroup } from './TagGroup';

export const ChippedSearchField = forwardRef((props, forwardedRef) => {
  const inputRef = useRef();
  const searchFieldState = useSearchFieldState(props);
  const searchField = useSearchField(props, searchFieldState, inputRef);
  const variant = props.variant;

  return (
    <S.Root className={props.className}>
      {(props.chips == null || props.chips.length === 0) && (
        <Glyph
          source={glyph.core.magnifyingglass}
          color={theme.icon.color_body_light}
          size={theme.icon.size_medium}
        />
      )}

      {props.chips?.length > 0 && (
        <TagGroup aria-label="Pre filter" onRemove={props.onRemoveChips}>
          {props.chips.map((chip) => {
            return <TagGroup.Item key={chip.key}>{chip.title}</TagGroup.Item>;
          })}
        </TagGroup>
      )}

      <S.Input
        {...searchField.inputProps}
        ref={mergeRefs([inputRef, forwardedRef])}
        variant={variant}
        backgroundColor={props.backgroundColor}
        borderRadius={props.borderRadius}
      />
    </S.Root>
  );
});

function S() {}
ChippedSearchField.S = S;

S.Root = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: ${su(5)};
  border: 1px solid ${theme.input.search_border};
  border-radius: 20px;
  background-color: ${theme.input.search_background};
  overflow: auto;
  padding: 8px;
  border: 1px solid transparent;
  transition: border-color ${motion.duration.fast} ${motion.curve.fast_in};

  .${glyphStyles.root} {
    margin-inline-end: 4px;
  }

  &:hover {
    border-color: ${theme.input.border_hover};
    box-shadow: ${theme.input.box_shadow_hover};
    background-color: ${theme.color.component};
  }

  &:focus-within {
    border-color: ${theme.input.border_focus};
    box-shadow: ${theme.input.box_shadow_focus};
    background-color: ${theme.color.component};
  }
`;

S.Input = styled.input`
  background-color: transparent;
  color: ${theme.color.text};
  caret-color: ${theme.color.mono_1000};
  border: none;
  outline: none;
  flex: 1 0 auto;
  width: 0;
  min-width: ${su(8)};
  margin-inline-start: 4px;

  &::placeholder {
    color: ${theme.color.text_light};
  }
`;
